import * as $ from 'jquery';

export default function init() {
	if ($('.__holidayGreeting').length === 0) {
		return;
	}

	/* setTimeout(() => { */
		for (var i = 0; i < 150; i++) {
			create(i);
		}
	/* }, 500); */

	function create(i: number) {
		/* var width = Math.random() * 8; */
		var width = Math.random() * 16;
		var height = width * 0.4;
		var colourIdx = Math.ceil(Math.random() * 3);
		var colour = "gold";
		switch (colourIdx) {
			case 1:
				colour = "yellow";
				break;
			case 2:
				colour = "blue";
				break;
			default:
				colour = "gold";
		}
		$('<div class="confetti-' + i + ' ' + colour + '"></div>').css({
			"width": width + "px",
			"height": height + "px",
			"top": -Math.random() * 20 + "%",
			"left": Math.random() * 100 + "%",
			"opacity": Math.random() + 0.5,
			"transform": "rotate(" + Math.random() * 360 + "deg)"
		}).appendTo('.pageWrapper');

		drop(i);
	}

	

	/* function drop(x: number) {
		$('.confetti-' + x).animate({
			top: "100%",
			left: "+=" + Math.random() * 15 + "%"
		}, Math.random() * 2000 + 2000, function () {
			reset(x);
		});
	} */

	function drop(x: number) {
		$('.confetti-' + x).delay(Math.random() * 5000).animate({
			top: "100%",
			left: "+=" + Math.random() * 15 + "%"
		}, Math.random() * 3000 + 3000, function () {
			reset(x);
		});
	}

	function reset(x: number) {
		$('.confetti-' + x).animate({
			"top": -Math.random() * 20 + "%",
			"left": "-=" + Math.random() * 15 + "%"
		}, 0, function () {
			drop(x);
		});
	}
}